import React from "react";
import { getDataFromLocalStorage, setDataInLocalStorage } from "utils/helper";
import { motion, Variants } from "framer-motion";
import Link from "next/link";
import { useRouter } from "next/router";

const CookiePopup = () => {
  const [closed, setClosed] = React.useState(true);
  const [height, setHeight] = React.useState(0);

  const setCookie = (value: boolean) => {
    setHeight(100);
    setDataInLocalStorage("cookie_consent", value);
  };

  const variants: Variants = {
    open: { opacity: 1, y: 0 },
    closed: { opacity: 0, y: height },
  };

  React.useEffect(() => {
    const consentCookie = getDataFromLocalStorage("cookie_consent");
    setClosed(!!consentCookie);
  }, []);

  return (
    !closed && (
      <motion.div
        animate={!height ? "open" : "closed"}
        variants={variants}
        className="text-white fixed w-full bottom-0 flex justify-center z-[1000]"
        id="cookie_consent"
      >
        <div className="bg-onmoPurple-100 max-w-[1156px] p-6 rounded-t-[20px] flex flex-col md:flex-row gap-2.5 text-sm text-onmoText items-center ">
          <p className="text-center md:text-left">
            We use cookies to enhance your browsing experience, serve
            personalised ads or content, and analyse our traffic.
            <br className="hidden md:flex" /> By clicking &quot;Accept all&quot;
            you consent to our use of cookies. Find more information on our use
            of cookies{" "}
            <Link aria-labelledby="Cookie" href="/legal/cookie-notice" passHref>
              <span className="text-onmoPrimary cursor-pointer">here</span>
            </Link>
            .
          </p>
          <div className="flex gap-2 text-base mt-6 md:mt-0">
            <button
              onClick={() => setCookie(false)}
              className="text-onmoPrimary  w-[140px] h-12"
            >
              Reject all
            </button>
            <button
              onClick={() => setCookie(true)}
              className="border-1 border-onmoPrimary bg-onmoPrimary text-white rounded-xl w-[140px] h-12"
            >
              Accept all
            </button>
          </div>
        </div>
      </motion.div>
    )
  );
};
export default function CookieProvider() {
  const path = useRouter().asPath;
  const isContractPage = path.includes("contracts-web");

  return <>{!isContractPage && <CookiePopup />}</>;
}
